module.exports = __webpack_public_path__ + "img/ta3.9d48774b.png";